<template>
	<div id="org_details">
		<div style="width: 100%;height: auto;background-color: white;">
			<img :src="organizationSeal" style="margin:0px 5%;width: 90%;height: auto;" />
		</div>
		<div style="background-color: white;font-size: 14px;">
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="description" /> <span class="org_span">组织名称 : {{linkman}}</span>
			</div>
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="coupon-o" /> <span class="org_span">机构代码: {{organizationCode}}</span>
			</div>
			<div class="org_item">
				<van-icon name="flag-o" /> <span class="org_span">机构地区 : {{regulatorArea}}</span>
			</div>
			<div class="org_item">
				<van-icon name="location-o" /> <span class="org_span">详细地址 : {{address}}</span>
			</div>
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="manager-o" /> <span class="org_span">负责人 : {{linkman}}</span>
			</div>
			<div class="org_item">
				<van-icon name="phone-o" /> <span class="org_span">手机号码: {{leaderCellphone}}</span>
			</div>
			<div class="org_item">
				<van-icon name="smile-comment-o" /> <span class="org_span">邮箱地址 : {{leaderEmail}}</span>
			</div>
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="notes-o" /> <span class="org_span">登记状态 : {{orgRecord}}</span>
			</div>
			<div class="org_item">
				<van-icon name="free-postage" /> <span class="org_span">服务类别 : {{serviceType}}</span>
			</div>
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="desktop-o" /> <span class="org_span">主管单位 : {{upOrgName}}</span>
			</div>
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="label-o" /> <span class="org_span">申请理由 : <span style="color: orangered;">{{orgIntroduction}}</span></span>
			</div>

			<div class="org_item">
				<van-icon name="info-o" /> <span class="org_span">申请日期 : {{regDate|formatDate}}</span>
			</div>

			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="sign" /><span class="org_span">机构证件 : </span>
				<van-swipe>
					<van-swipe-item v-for="(image, index) in images" :key="index">
						<img :src="image" style="height: 200px;width: 90%;margin: 5%;" @click="ImageView(index)" />
					</van-swipe-item>
				</van-swipe>
			</div>
			<div style="margin: 10px 0px 10px  28%;height: 80px;">
				<van-button @click="examineOrg(3)" type="danger">不通过</van-button>
				<van-button @click="examineOrg(2)" style="margin-left: 40px;" type="primary">通过</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { Cell, CellGroup, Dialog, Pagination, NavBar, Popup, Search, Loading, Toast, Icon, Area, Picker, Button, Swipe, SwipeItem, ImagePreview } from 'vant';
	import axios from 'axios';
	import store from '@/store/store.js';
	import global from '@/api/global';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	Vue.use(VueCookies);
	export default {
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd hh:mm:ss');
			},
			addPath(path) {
				return global.resoursePhoto + "/" + path;
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Dialog.name]: Dialog,
			[Pagination.name]: Pagination,
			[NavBar.name]: NavBar,
			[Popup.name]: Popup,
			[axios.name]: axios,
			[Search.name]: Search,
			[Loading.name]: Loading,
			[Toast.name]: Toast,
			[Icon.name]: Icon,
			[Area.name]: Area,
			[Picker.name]: Picker,
			[Button.name]: Button,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[ImagePreview.name]: ImagePreview
		},
		data() {
			return {
				images: [],
				orgName: "",
				organizationCode: "",
				orgRecord: "",
				orgIntroduction: "",
				upOrgName: "",
				linkman: "",
				leaderCellphone: "",
				leaderEmail: "",
				serviceType: "",
				regDate: "",
				regulatorArea: "",
				address: "",
				organizationSeal: "",
				checked: 0,
				checked_text: "申请加入"
			}
		},
		created: function() {
			this.getInfo();
		},
		methods: {
			ImageView(index) {
				ImagePreview({
					images: this.images,
					startPosition: index,
					onClose() {
						// do something
					}
				});
			},
			login() {
				this.$router.push({
					path: '/login'
				});
			},
			getInfo() { //获取组织信息
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/select',
					params: {
						"id": this.$route.query.id,
						"auth_token": this.$cookies.get("auth_token")
					}
				}).then((resp) => {
					var org = resp.data.data;
					if(org.status != 1){
						this.$router.back(-1);
						return false;
					}
					this.organizationCode = org.organizationCode,
					this.orgRecord = org.orgRecord,
					this.orgIntroduction = org.orgIntroduction,
					this.upOrgName = org.upOrgName,
					this.linkman = org.linkman;
					this.leaderCellphone = org.leaderCellphone;
					this.leaderEmail = org.leaderEmail;
					this.serviceType = org.serviceType;
					this.regDate = org.regDate;
					this.regulatorArea = org.regulatorArea;
					this.address = org.address;
					this.organizationSeal = global.resoursePhoto + "/" + org.organizationSeal;
					var images = org.recordCertificate.split(',');
					for(var i = 0; i < images.length; i++) {
						this.images.push(global.resoursePhoto + "/" + images[i]);
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					console.log(resp);
					Toast.fail('请求失败');
				});
			},
			examineOrg(examine) { //同意或不同意
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/ExamineOrg',
					params: {
						"orgid": this.$route.query.id,
						"examine": examine,
						"auth_token": this.$cookies.get("auth_token")
					}
				}).then((resp) => {
					Toast.success(resp.data.msg);
					if(resp.data.status == 1) {
						setTimeout(() => {
							this.$router.push({
								path: '/organization_list'
							});
						}, 1000);
					}
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			}
		}
	}
</script>

<style>
	#org_details .active_button {
		background-color: orangered !important
	}
	
	#org_details .org_item {
		margin: 10px 5%;
	}
	
	#org_details .org_span {
		vertical-align: middle;
		margin-left: 6px;
	}
	
	#org_details .van-icon,
	#org_details .van-icon::before {
		vertical-align: middle;
	}
</style>